
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressArrow from "../../../assets/ProgressArrow.vue";
import { permission } from '@pazion/pazion-core/src/store';
import { 
  _IOrderManagment, 
  _IOrderManagmentStatusItems, 
  _IOrderManagmentStatusMapping 
  } from '@pazion/pazion-core/src/models/permission-model';

@Component({
  components: {
    ProgressArrow
  }
})
export default class PazOrderMappedStatus extends Vue {
  @Prop({ default: '' })
  public orderStatus!: string;

  @Prop({ default: 'sales' })
  public orderType!: string;

  @Prop({ default: true })
  public displayInvoiceStatus!: boolean;


  /** 
   * TODO: New code
   * */
  //NOTE: GET current step by an order status
  findStatusEntry() {
    return this.getStatusMapping.map(en => {
      if (Object.values(en.status).find(st => st === this.orderStatus)) {
        return en && en;
      }
    }).filter(entry => entry !== undefined)
  }

  /** 
   * SECTION
  @prop item: {
    enabled: true
    icon: "mdi-cart-outline"
    name:"cart"
    step: 1
    }
    @retutn 'red', 'green', 'gray', 'orange'
  */
 /* 
  * NOTE: define color by status, match is orange, 
  all below is green, all above is grey.
  */ 
  getStatusType(item: _IOrderManagmentStatusItems) {
    const specStep = this.getStatusEntry?.step;
    const lineStep = item.step

    //NOTE: ERROR status: First red, other grey
    if (specStep === -1) {
      return  item.step === 1 ? 'red' : 'grey'
    }

    //NOTE: REGULAR statuses
    if (lineStep === specStep) {
      return 'orange'
    } else if (specStep > lineStep) {
      return 'green'
    } else {
      return 'grey'
    }
  }

  get getStatusProps():_IOrderManagment {
    return permission?.getConfig.orderManagement
  }

  get getStatusesItems():_IOrderManagmentStatusItems[] {
    return this.getStatusProps && Object.values(this.getStatusProps.statusItems)
  }

  get getStatusMapping():_IOrderManagmentStatusMapping[] {
    return this.getStatusProps && Object.values(this.getStatusProps.statusMapping)
  }


  get getStatusEntry() {
    const findedEntireStatus = this.findStatusEntry();
    if(findedEntireStatus && findedEntireStatus.length)
      return this.findStatusEntry() && this.findStatusEntry().shift()
  }
}//
